module.exports = "/_next/static/images/gmc-popup-a7b37e929aa12d626d9428b6f6e4fcb1.svg";